/**
 * @name DenialCriteria.SS2Model.js
 * @author AnchorGroup : Kalpa
 * @description Used to track user's IP address.
 * @update 2025-07-16
 */
define("DenialCriteria.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";
    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/DenialCriteriaModule/SuiteScript2/DenialCriteriaModule.Service.ss"
            ),
            true
        )
    });
});
